import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Link from '@mui/material/Link';
import { GridColDef } from '@mui/x-data-grid-pro';

import DataGridTable from '@/shared/components/dataDisplay/DataGridTable/DataGridTable';
import TableInstance from '@/shared/constants/tableInstance';
import FulfilmentOrder from '@/shared/types/fulfilment/order.type';

import ShippingLabelsDropdown from './components/ShippingLabelsDropdown';
import useFulfilmentOrdersTable_v2 from './hooks/useFulfilmentOrdersTable_v2';

type FulfilmentOrdersTable_v2Props = {
  orderId: string;
};

const FulfilmentOrdersTable_v2: FC<FulfilmentOrdersTable_v2Props> = ({
  orderId,
}) => {
  const { t } = useTranslation(['orders', 'common']);

  const { apiRef, model, table, columns, visibilityModel, setVisibilityModel } =
    useFulfilmentOrdersTable_v2({ orderId });

  const customizedColumns: GridColDef[] = columns.map((column) => {
    switch (column.field) {
      case 'tracking_number':
        return {
          ...column,
          width: 250,
          renderCell(params) {
            const row = params.row as FulfilmentOrder;
            return (
              <Link component='a' href={row.tracking_url} target='_blank'>
                {row.tracking_number}
              </Link>
            );
          },
        };
      case 'shipping_labels':
        return {
          ...column,
          width: 250,
          renderCell(params) {
            const row = params.row as FulfilmentOrder;

            if (row.shipping_labels) {
              return (
                <ShippingLabelsDropdown shipping_labels={row.shipping_labels} />
              );
            }
            return <></>;
          },
        };
      default:
        return column;
    }
  });

  return (
    <div style={{ height: '60vh', width: '100%' }}>
      <DataGridTable
        getRowId={(item) => item.fulfilment_id as string}
        columns={customizedColumns}
        rows={table.data}
        rowCount={table.totalRows}
        loading={table.isLoading}
        columnVisibilityModel={visibilityModel}
        onColumnVisibilityModelChange={setVisibilityModel}
        checkboxSelection={false}
        customProps={{
          tableInstance: TableInstance.FulfilmentOrders,
          apiRef,
          model,
          toolbar: {
            title: t('orders:fulfilmentOrders'),
          },
        }}
      />
    </div>
  );
};

export default FulfilmentOrdersTable_v2;
